export default __webpack_public_path__ + "static/media/grazia.6c31048a.jpg";